// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubmenuItem_wrapper__UpMn_","listNavigation":"SubmenuItem_listNavigation__vtq6u","tiles":"SubmenuItem_tiles__ANVQq"};